import { render, staticRenderFns } from "./AbnormalCasesReport.vue?vue&type=template&id=3d70fb76&scoped=true"
import script from "./AbnormalCasesReport.vue?vue&type=script&lang=js"
export * from "./AbnormalCasesReport.vue?vue&type=script&lang=js"
import style0 from "./AbnormalCasesReport.vue?vue&type=style&index=0&id=3d70fb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70fb76",
  null
  
)

export default component.exports